/**
 * Какая переписка открыта на экране прямо сейчас (и видна ли она).
 * Нужно службе событий: пришло сообщение в открытую переписку — сразу отмечаем прочитанным.
 */
export interface OpenConversation {
  accountId: number;
  id: number;
}

let current: OpenConversation | null = null;

export function setOpenConversation(c: OpenConversation | null): void {
  current = c;
}

export function getOpenConversation(): OpenConversation | null {
  return current;
}

export function isOpen(accountId: number, id: number): boolean {
  return current?.accountId === accountId && current.id === id;
}
